// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://api-vcc.avsstech.in/api/v1',
  wsUrl: 'wss://api-vcc.avsstech.in',
  // apiUrl: 'http://localhost:5000/api/v1',
  // wsUrl: 'ws://localhost:5000',
  chatApiUrl: 'https://api-vcc.avsstech.in/api/v1',
  widgetJsUrl: 'https://vcc.avsstech.in/cdn/chat-widget.js',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
